/**
 * RecorderError.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import ExtendableError from 'es6-error';


export default class RecorderError extends ExtendableError {
    /**
     * Creates RecorderError instance.
     *
     * @param {message} message of the error
     */
    constructor(message = 'message not defined') {
        const errorMessage = JSON.stringify(message);
        super(errorMessage);
    }
}
